import { Component, OnInit, ViewChild } from '@angular/core';
import { MatDialog, MatDialogConfig, MatDialogRef } from '@angular/material/dialog';
import { MatTable, MatTableDataSource } from '@angular/material/table';
import { CategoryEventsService } from 'app/_services/category-events.service';
import { DialogsService } from 'app/_services/dialogs/dialogs.service';
import { NotificationService } from 'app/_services/notification.service';
import { UserService } from 'app/_services/user.service';
import { Category } from '../category';
import { EditCategoryDialogComponent } from '../edit-category-dialog/edit-category-dialog.component';

@Component({
    selector: 'app-category-events',
    templateUrl: './category-events.component.html',
    styleUrls: ['../../shared/table-defaults.scss', '../categories.component.scss'],
})
export class CategoryEventsComponent implements OnInit {
    categories: Category[];
    categoryNames: string[];
    dataSource: MatTableDataSource<Category>;

    displayedColumns: string[] = ['Name', 'Active', 'DateCreated', 'DateUpdated', 'UpdatedBySapid', 'actions'];
    columnsToDisplay = this.displayedColumns.slice();

    @ViewChild(MatTable) table: MatTable<Category[]>;

    constructor(
        private userService: UserService,
        private catEventService: CategoryEventsService,
        public dialog: MatDialog,
        private dialogSerivce: DialogsService,
        private notificationService: NotificationService
    ) {}

    ngOnInit(): void {
        this.catEventService.getCategories().subscribe((categories) => {
            this.categories = categories;
            this.loadDatasource(this.categories);
            this.categoryNames = this.categories.map((category) => category.name);
        });
    }

    loadDatasource(data: Category[]): void {
        this.dataSource = new MatTableDataSource(data);
    }

    newCategory(): Category {
        return {
            categoryId: 0,
            name: null,
            active: true,
            dateCreated: null,
            dateUpdated: null,
            updatedBySapid: null,
        };
    }

    openEditCategoryDialog(category: Category, categoryNames: string[], title: string): MatDialogRef<EditCategoryDialogComponent> {
        const config: MatDialogConfig = {
            width: '80vw',
            maxWidth: '600px',
            panelClass: 'categoryEditor',
            data: { category, categoryNames, title },
        };

        return this.dialog.open(EditCategoryDialogComponent, config);
    }

    addCategory(): void {
        const categories = this.categories;
        const categoryNames = this.categoryNames;
        const title = 'Add Category';
        const user = this.userService.UserValue;

        // Make a new cateogry and add index
        const category = this.newCategory();

        const dialogResult = this.openEditCategoryDialog(category, categoryNames, title);

        dialogResult.afterClosed().subscribe((result: Category) => {
            if (!result) {
                return;
            }

            // Change UpdatedbySapid field to reflect current user
            result.updatedBySapid = user.sapid.toString();

            this.catEventService.createCategory(result).subscribe((res) => {
                categories.push(res);
                this.loadDatasource(categories);
                this.notificationService.showSuccess(`Category has been added.`);
            });
        });
    }

    editCategory(category: Category): void {
        const categoryNames = this.categoryNames;
        const title = `Edit Category - ${category.name}`;
        const user = this.userService.UserValue;

        const dialogResult = this.openEditCategoryDialog(category, categoryNames, title);

        dialogResult.afterClosed().subscribe((result: Category) => {
            if (!result) {
                return;
            }

            // Change UpdatedbySapid field to reflect current user
            result.updatedBySapid = user.sapid.toString();

            this.catEventService.updateCategory(result.categoryId, result).subscribe();

            this.notificationService.showSuccess(`Category has been updated.`);
        });
    }

    deleteCategory(category: Category): void {
        const dialogResult$ = this.dialogSerivce.OpenConfirmationDialog({
            TitleText: `Delete Category - ${category.name}`,
            MessageText: 'Are you sure you want to delete this category?',
            SubMessageText: 'Deleting this category will also remove it from all calendar events and feeds. THIS CANNOT BE UNDONE!',
            OKText: 'Yes, remove category',
            CancelText: 'No',
            DelayDelete: 5, // Number of seconds to delay delete button
        });

        dialogResult$.subscribe((result) => {
            if (!result) {
                return;
            }

            const index = this.dataSource.data.indexOf(category, 0);

            if (index > -1) {
                this.dataSource.data.splice(index, 1);
            }

            this.catEventService.deleteCategory(category.categoryId).subscribe();
            this.table.renderRows();
            this.notificationService.showSuccess(`Category have been removed.`);
        });
    }
}
